import { type TFunction } from "i18next";

export interface ApiErrorBody {
  error: { message: string; code?: string };
}

export function getProductErrorMessage(
  t: TFunction,
  error: ApiErrorBody,
): string {
  switch (error.error.code) {
    case "STRIPE_ACCOUNT_NOT_READY":
      return t("productsPage.publishRequiresReady");
    case "PROFILE_REQUIRED":
      return t("productsPage.publishRequiresProfile");
    case "NO_ACTIVE_PRICE":
      return t("productsPage.publishRequiresPrice");
    case "LAST_ACTIVE_PRICE":
      return t("productsPage.priceDialog.lastActive");
    case "SLUG_TAKEN":
      return t("productsPage.form.slugTaken");
    case "ACCESS_ENDS_IN_PAST":
      return t("productsPage.form.accessEndsInPast");
    case "NOT_FOR_SALE":
      return t("publicProduct.paused");
    case "ATHLETE_LIMIT_REACHED":
      return t("publicProduct.athleteLimitReachedShort");
    case "ALREADY_SUBSCRIBED":
      return t("publicProduct.alreadySubscribed");
    case "DUPLICATE_SUBSCRIPTION":
      return t("publicProduct.duplicateRefunded");
    case "STRIPE_ACCOUNT_NOT_CONNECTED":
      return t("productsPage.stripeNotConnected");
    case "STRIPE_REFUSED":
      return error.error.message;
    case "PROMO_CODE_TAKEN":
      return t("productsPage.promoCodes.form.codeTaken");
    case "PROMO_CODE_EXPIRES_IN_PAST":
      return t("productsPage.promoCodes.form.expiresInPast");
    case "INVOICING_NOT_AVAILABLE":
      return t("productsPage.invoicing.notAvailable");
    case "INVOICING_API_KEY_REQUIRED":
      return t("productsPage.invoicing.apiKeyRequired");
    case "INVOICING_CREDENTIALS_REJECTED":
      return t("productsPage.invoicing.credentialsRejected");
    case "INVOICING_UNAVAILABLE":
      return t("productsPage.invoicing.unavailable");
    case "INVOICING_REJECTED":
      return t("productsPage.invoicing.connectionRejected", {
        detail: error.error.message,
      });
    case "INVOICING_NOT_CONNECTED":
      return t("productPayments.invoicingNotConnected");
    case "INVOICE_IN_PROGRESS":
      return t("productPayments.invoiceInProgress");
    case "NOTHING_TO_INVOICE":
      return t("productPayments.nothingToInvoice");
    default:
      return t("productsPage.tryAgainLater");
  }
}
